import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomPlayStore({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3 16.905V3.096c0-.482.291-.898.713-1.096l8.321 7.998L3.71 18A1.215 1.215 0 013 16.905zm11.674-4.37l-9.098 5.05 7.175-6.897 1.923 1.848zm2.828-3.502c.303.222.498.573.498.968a1.2 1.2 0 01-.484.958l-1.933 1.072-2.115-2.033 2.114-2.031 1.92 1.066zM5.581 2.417l9.092 5.045L12.75 9.31l-7.17-6.892z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomPlayStore;
